import React, { useState } from 'react';
import { Calculator, Wrench } from 'lucide-react';
import CustomerPriceCalculator from './CustomerPriceCalculator';
import CustomerPortalLayout from '../../components/customer-portal/CustomerPortalLayout';

const CustomerTools = () => {
  const [activeTab, setActiveTab] = useState('price-calculator');

  const tabs = [
    {
      id: 'price-calculator',
      label: 'Fiyat Hesaplama',
      icon: Calculator,
      component: CustomerPriceCalculator
    }
    // İleride daha fazla tab eklenebilir
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <CustomerPortalLayout title="Araçlar" icon={Wrench} showBackButton={true}>
      <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-8">
        {/* Tabs */}
        <div className="mb-4 sm:mb-6 border-b border-gray-200 dark:border-gray-700">
          <nav className="flex space-x-4 sm:space-x-8 overflow-x-auto" aria-label="Tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center gap-1.5 sm:gap-2 py-3 sm:py-4 px-1 border-b-2 font-medium text-xs sm:text-sm transition-colors whitespace-nowrap flex-shrink-0
                    ${
                      activeTab === tab.id
                        ? 'border-orange-500 text-orange-600 dark:text-orange-400'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                    }
                  `}
                >
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        <div>
          {ActiveComponent && <ActiveComponent />}
        </div>
      </main>
    </CustomerPortalLayout>
  );
};

export default CustomerTools;
